import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Preferences() {
  return (
    <ScaffoldPage
      title="Notification Settings"
      description="Configure notification channels and delivery preferences."
      breadcrumbs={buildBreadcrumbs('/settings/notifications/preferences')}
      plannedFeatures={[
        'Per-channel notification controls (email, in-app, webhook)',
        'Notification frequency and batching preferences',
        'Quiet hours and delivery scheduling',
        'Per-user notification override settings',
      ]}
      relatedPages={[
        { label: 'Alert Rules', href: '/settings/notifications/alerts' },
      ]}
    />
  )
}
